/** Aligné sur backend/src/services/academiaDocumentService.ts */

export const IDENTITY_DOCUMENT_TYPES = [
  'PIECE_IDENTITE',
  'PASSEPORT',
  'PERMIS_CONDUIRE',
  'CARTE_ELECTEUR',
];

export const IDENTITY_DOCUMENT_LABELS = {
  PIECE_IDENTITE: "Carte d'identité / CNI",
  PASSEPORT: 'Passeport',
  PERMIS_CONDUIRE: 'Permis de conduire',
  CARTE_ELECTEUR: "Carte d'électeur",
};

export const APPRENANT_DOCUMENT_LABELS = {
  ...IDENTITY_DOCUMENT_LABELS,
  PHOTO: 'Photo',
  ATTESTATION: 'Attestation',
  DIPLOME: 'Diplôme',
  AUTRE: 'Autre',
};

export function isIdentityDocumentType(type) {
  return IDENTITY_DOCUMENT_TYPES.includes(type);
}

export function getApprenantDocumentLabel(type) {
  return APPRENANT_DOCUMENT_LABELS[type] ?? type;
}
